import { render, staticRenderFns } from "./payment-payable-detail.vue?vue&type=template&id=45918008"
import script from "./payment-payable-detail.vue?vue&type=script&lang=js"
export * from "./payment-payable-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports